import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps"

export default {
	registerUser: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.AUTH].REGISTER_USER
	},
	loginUser: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.AUTH].LOGIN_USER
	},
	resendEmailConfirmation: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.AUTH].RESEND_EMAIL_CONFIRMATION
	},
}
